// extracted by mini-css-extract-plugin
export default {"input":"haa-z","button":"iaa-z","selected":"jaa-z","unavailable":"kaa-z","oos":"laa-z","paperCutDisabledOverlay":"maa-z","image":"naa-z"};